import React from 'react';
import styled from 'styled-components';
import Button from './Button';

const Card = styled.div`
  background-color: #1E1E1E;
  border-radius: 12px;
  padding: 32px;
  color: #E0E0E0;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
  
  ${props => props.isPopular && `
    position: relative;
    border: 2px solid #FFD700;
    transform: scale(1.05);
    
    @media (max-width: 768px) {
      transform: scale(1);
      margin: 32px 0;
    }
  `}
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    
    ${props => props.isPopular && `
      transform: translateY(-5px) scale(1.05);
      
      @media (max-width: 768px) {
        transform: translateY(-5px);
      }
    `}
  }
`;

const PopularTag = styled.div`
  position: absolute;
  top: -15px;
  right: 20px;
  background-color: #FFD700;
  color: #121212;
  font-weight: bold;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
`;

const Title = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 8px;
  color: #FFFFFF;
`;

const Price = styled.div`
  margin: 24px 0;
  
  .regular-price {
    text-decoration: line-through;
    color: #999;
    font-size: 20px;
    margin-right: 10px;
  }
  
  .sale-price {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 32px;
    color: #FFFFFF;
  }
  
  .period {
    font-size: 16px;
    color: #999;
  }
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 32px 0;
  flex-grow: 1;
  
  li {
    padding: 8px 0;
    position: relative;
    padding-left: 30px;
    
    &:before {
      content: "✓";
      position: absolute;
      left: 0;
      color: #00C853;
      font-weight: bold;
    }
  }
`;

const Trial = styled.p`
  font-size: 14px;
  margin-bottom: 24px;
  color: #00C853;
`;

const PricingCard = ({
  title,
  regularPrice,
  salePrice,
  period = '/month',
  features = [],
  isPopular = false,
  trialDays = 7,
  buttonText = "Try Now",
  buttonVariant = "primary",
  sectionName = "pricing"
}) => {
  return (
    <Card isPopular={isPopular}>
      {isPopular && <PopularTag>Most Popular</PopularTag>}
      <Title>{title}</Title>
      
      <Price>
        {regularPrice && <span className="regular-price">${regularPrice}</span>}
        <span className="sale-price">${salePrice}</span>
        <span className="period">{period}</span>
      </Price>
      
      <Trial style={{ color: '#FFD700' }}>30 days money back guarantee</Trial>
      
      <FeatureList>
        {features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </FeatureList>
      
      <Button 
        variant={buttonVariant} 
        size="large" 
        id={`${title.toLowerCase().replace(/\s+/g, '-')}-button`}
        sectionName={sectionName}
        onClick={() => window.location.href = 'https://app.carconsul.com'}
        additionalData={{ 
          plan: title, 
          price: salePrice,
          isPopular
        }}
      >
        {buttonText}
      </Button>
    </Card>
  );
};

export default PricingCard;
